export default function getWFD(answer, result) {
    let answers = answer.replace(/[,.]/g, '').replace(/\s+/g, ' ').split(' ').map(v => v.split('/').map(v1 => v1.startsWith('^') ? v1.replace('^', '') : v1.toLowerCase()))
    const results = result.replace(/[,.]/g, '').replace(/\s+/g, ' ').split(' ')
    const words = []
    results.forEach((word, index) => {
        if (word) {
            const indexs = []
            for (let i = 0; i < answers.length; i++) {
                if (answers[i].includes(word) || answers[i].includes(word.toLowerCase())) {
                    indexs.push(i)
                }
            }
            if (indexs.length == 0) {
                words.push({ word, class: 'wrong2' })
                results.splice(index, 1, '')
            } else {
                let maxCount = 0;
                let index1 = indexs[0]
                indexs.forEach(i => {
                    let count = 0
                    for (let j = i; j < answers.length; j++) {
                        const word1 = results[j - i + index]
                        if (!word1) break;
                        if (answers[j].includes(word1) || answers[j].includes(word1.toLowerCase())) {
                            count++
                        } else {
                            break;
                        }
                    }
                    if (count > maxCount) {
                        maxCount = count;
                        index1 = i
                    }
                })
                for (let k = 0; k < maxCount; k++) {
                    words.push({ word: results[index + k], index: index1 + k, class: 'right' })
                    results.splice(index + k, 1, '')
                    answers.splice(index1 + k, 1, '')
                }
            }
        }
    })
    words.forEach(word => {
        if (word.index > 0) {
            for (let index = 0; index < word.index; index++) {
                if (answers[index]) {
                    if (!word.items) word.items = []
                    word.items.push({ word: answers[index].join('/'), class: 'wrong1' })
                    answers.splice(index, 1, '')
                }
            }
        }
    })

    const list = []

    words.forEach(word => {
        if (word.items) {
            word.items.forEach(item => {
                list.push(item)
            })
            delete word.items
        }
        delete word.index
        list.push(word)
    })
    answers.forEach(answer => {
        if (answer) {
            list.push({ word: answer.join('/'), class: 'wrong1' })
        }
    })

    list.forEach((item, index) => {
        if (item.class == 'wrong1') {
            if (index == 0 || list[index - 1].class != 'wrong1') {
                item.word = '(' + item.word
            }
            if (index == list.length - 1 || list[index + 1].class != 'wrong1') {
                item.word = item.word + ')'
            }
        }
    })
    
    return list
}

// // // 测试
// const sentence1 = 'Students are advised that all the lectures today have been canceled/cancelled.'
// const sentence2 = 'the cancelled.'

// const sentence1 = 'The new technician dropped the microscope in the biology lab.'
// const sentence2 = 'The new tech dropped microscope biology lab.'
// const result3 = getWFD(sentence1, sentence2);
// console.log("所有连续匹配:", result3);

